<template>
 <div class="ui centered grid">
    <div class="three wide column"></div>
    <div class="ten wide column">
        <div v-if="logged">
            <div class="ui hidden message" style="margin-bottom:25px;" v-bind:class="{'positive':messageType=='positive','negative':messageType=='negative'}" id="message">
                <i class="close icon" v-on:click="hideMessage()"></i>
                <div class="header" style="padding-left:30px">{{message}}</div>
            </div>
            <div>
                <div class="ui active bottom attached tab segment" data-tab="">
                    <TheNoteForm v-bind:blank="blank" v-bind:noteid="noteId"></TheNoteForm>
                </div>
            </div>
        </div>
    </div>
    <div class="three wide column"></div>
</div>
</template>

<script>
  import TheNoteForm from '../components/TheNoteForm.vue'
  export default {
    name: 'list',
    components: {
      TheNoteForm
    },
    data() {
      return {
        message: "",
        blank: true,
        noteId: "blank",
        messageType: "negative",
        logged: false,
        loading: true,
        user_msg: "",
        userData: {
          uuid: "",
          username: "",
          first_name: "",
          last_name: "",
          email: "",
          role: "",
        }
      }
    },


    methods: {
      showMessage: function(messageType, message) {
        this.message = message;
        this.messageType = messageType;
        $('#message').transition('fade up');
      },
      hideMessage: function(s) {
        setTimeout(function() {
          $('#message').transition('fade up');
        }, s * 1000);

        // this.messageVisible = false;
      },

      loadNoteData: function(uuid) {
        axios
          .get('/api/note/' + uuid)
          .then(response => {
            this.userData = response.data;
          });
      },

      closeUserForm: function(status) {
        if (status == 201) {
          this.showMessage('positive', "Note updated succesfully.");
        }
        else {
          this.showMessage('negative', "Cannot update note. Server response: " + status);
        }
        this.hideMessage(5);
      }
    },

    mounted() {
      if (this.$route.params.noteid != 'blank') {
        this.blank = false;
        this.noteId = this.$route.params.noteid;
      }
      axios
        .get('/api/isauth/')
        .then(response => {
          if (response.data.isauth) {
            this.logged = true;
            //this.loadUserData(response.data.uuid);

          }
          else {
            this.logged = false;

          }
        })


    },

    /*  watch: {
        $route(to, from) {
          this.loadUserData();
        }
      }*/
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/note.vue